<template>
  <div class="performance">
    <div class="box">
      <div class="box_1">
        <div>
          <img src="../../assets/rectangle.png" alt />
          <span class="rectangleSpan">测评表答题详情</span>
        </div>
        <div>
          <el-button round type="danger" class="back" @click="btnBack">返回</el-button>
        </div>
      </div>
      <div class="grade_box3_one">
        <div v-for="item in questionList" :key="item.showA">
          <!-- <div v-if="item.showA=='1'" class="textNumOne">
            <div class="exer">{{item.name}}</div>
            <div class="exer" v-for="obj in item.list" :key="obj.name">
              <div class="obstaOne">
                <div>{{obj.pid}}</div>
                <div>{{ filterVoice(obj.voice)}}</div>
                <div>{{ filterLanguage(obj.language)}}</div>
                <div>{{ filterIntonation(obj.intonation)}}</div>
              </div>
            </div>
          </div>-->
          <div v-if="item.showA=='2'" class="textNumTwo">
            <div class="exer">{{item.name}}</div>
            <div v-for="obj in item.list" :key="obj.name" class="twoList">
              <div class="obstaTwo">
                <div>{{obj.pid}}、</div>
                <div>{{ filterGrade(obj.grade)}}</div>
              </div>
              <div class="zooListRes" v-if="obj.zooList">
                <div v-for="res in obj.zooList" :key="res.name">
                  <div class="pidRes">
                    <div>{{res.pid}}</div>
                    <div>{{ filterGrade(res.grade)}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div v-if="item.showA=='3'" class="textNumThree">
            <div class="exer">{{item.name}}</div>
            <div v-for="obj in item.list" :key="obj.name" class="twoList">
              <div class="obstaTwo">
                <div>{{obj.pid}}、</div>
                <div>
                  <div v-for="res in obj.checkListErr" :key="res">{{ filterRes(res) }}</div>
                </div>
                <div>
                  <div v-for="(res,index) in obj.checkListErr2" :key="index">{{ filterRes2(res) }}</div>
                </div>
              </div>
            </div>
          </div>-->
          <div v-if="item.showA=='4'" class="textNumFour">
            <div class="exer">{{item.name}}</div>
            <div v-for="obj in item.list" :key="obj.name" class="twoList">
              <div class="obstaTwo">
                <div>{{obj.pid}}、</div>
                <div>{{ filterGrade(obj.grade)}}</div>
              </div>
              <div class="zooListRes" v-if="obj.zooList">
                <div v-for="res in obj.zooList" :key="res.name">
                  <div class="pidRes">
                    <div>{{res.pid}}</div>
                    <div>{{ filterGrade(res.grade)}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "performance",
  components: {},
  props: {},
  data() {
    return {
      questionList: [],
      checkList: []
    };
  },
  created() {
    this.questionInfosList();
  },
  mounted() {},
  watch: {},
  computed: {},
  methods: {
    questionInfosList() {
      this.questionList = JSON.parse(sessionStorage.getItem("questionList"));
      console.log(this.questionList);
    },
    btnBack() {
      this.$router.go(-1);
    },
    filterVoice(value) {
      if (value == 1) {
        return "正常";
      } else {
        return "异常";
      }
    },
    filterLanguage(value) {
      if (value == 1) {
        return "流畅";
      } else {
        return "不流畅";
      }
    },
    filterIntonation(value) {
      if (value == 1) {
        return "正常";
      } else {
        return "异常";
      }
    },
    filterGrade(value) {
      if (value == 1) {
        return "1分";
      } else if (value == 2) {
        return "0分";
      } else if (value == 3) {
        return "无反应";
      }
    },
    filterRes(value) {
      if (value == "1") {
        return "阴（第一声）";
      } else if (value == "2") {
        return "阳（第二声）";
      } else if (value == "3") {
        return "上（第三声）";
      } else if (value == "4") {
        return "去（第四声）";
      }
    },
    filterRes2(value) {
      if (value == "1") {
        return "代替";
      } else if (value == "2") {
        return "省略";
      } else if (value == "3") {
        return "歪曲";
      } else if (value == "4") {
        return "整体含糊不清";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.performance {
  background-image: url("~@/assets/appraisal.png"); // 设置背景图片
  background-attachment: fixed;
  background-position: center;
  // background-size: 100% 100%;
  background-size: cover;
  // height: 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  //   padding-top: 33px;
  padding-bottom: 30px;

  //   height: 100vh;
  .box {
    margin-top: 33px;
    width: 1200px;
    background-color: #fff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    // align-content: flex-start;
    // flex-wrap: wrap;
    padding-top: 49px;
    padding-left: 21px;
  }
}
.rectangleSpan {
  margin-left: 15px;
  font-size: 24px;
}
.grade_box3_one {
  //   height: 1400px;
  height: 1050px;
  margin-top: 20px;
  column-count: 3;
  column-gap: 20px;
}
// .grade_box3_one_exer {
//   display: flex;
//   margin-bottom: 10px;
//   .exer {
//     font-size: 20px;
//     margin-right: 20px;
//   }
// }
.exer {
  font-size: 20px;
  margin-right: 20px;
}

.textNum {
  font-size: 20px;
  margin-top: 2px;
}

.box_1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.back {
  margin-right: 30px;
}

.obstaOne {
  display: flex;
  justify-content: space-around;
  margin: 10px 0;
}

.obstaTwo {
  display: flex;
  justify-content: space-around;
  //   margin: 10px 0;
}
.twoList {
  margin: 10px 0;
}
.zooListRes {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .pidRes {
    display: flex;
    justify-content: space-around;
    margin-left: 20px;
  }
}
.textNumOne {
  height: 300px;
  width: 300px;
  //   background-color: beige;
}
.textNumTwo {
  height: 1300px;
  width: 300px;
  //   background-color: red;
}
.textNumThree {
  height: 600px;
  width: 310px;
  //   background-color: beige;
}
.textNumFour {
  height: 1000px;
  width: 300px;
}
</style>